module.exports = __webpack_public_path__ + "static/media/broadband_desktop_banner.c96a4871.png";